// =============================================================================
//  KOMPONENTE: ClubList
// =============================================================================
//  Zweck: Stellt eine Liste von Vereinen in einer Tabelle dar.
// =============================================================================
import React from 'react';

// Die Komponente erhält jetzt zwei neue Funktionen als Props: onEdit und onDelete
const ClubList = ({ clubs, onEdit, onDelete }) => {
  return (
    <div className="table-container">
      <h3>Bestehende Vereine</h3>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Ansprechperson</th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Aktionen</th> {/* <-- NEUE SPALTE */}
          </tr>
        </thead>
        <tbody>
          {clubs.length > 0 ? (
            clubs.map((club) => (
              <tr key={club._id}>
                <td>{club.name}</td>
                <td>{club.contactPerson}</td>
                <td>{club.email}</td>
                <td>{club.phone}</td>
                {/* Zelle für die Aktions-Buttons */}
                <td>
                  <button className="btn-edit" onClick={() => onEdit(club)}>
                    Bearbeiten
                  </button>
                  <button className="btn-delete" onClick={() => onDelete(club._id)}>
                    Löschen
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">Noch keine Vereine angelegt.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ClubList;